import { render, staticRenderFns } from "./ImporvementPlans.vue?vue&type=template&id=c6c7d760&"
import script from "./ImporvementPlans.vue?vue&type=script&lang=js&"
export * from "./ImporvementPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports